import React, { useState } from 'react';
import './Gallery.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';
import { mainGalleryData, galleryCategories } from '../../data/maingallery';

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredItems =
    activeFilter === 'All'
      ? mainGalleryData
      : mainGalleryData.filter(item => item.category === activeFilter);

  return (
    <div className="gallery-page">
      <Navbar />

      <div className="gallery-container">
        <div className="page-header">
          <h1>University Gallery</h1>
          <div className="header-underline"></div>
        </div>

        <div className="gallery-filters">
          {galleryCategories.map(category => (
            <button
              key={category.id}
              className={`filter-button ${activeFilter === category.id ? 'active' : ''}`}
              onClick={() => setActiveFilter(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        <div className="gallery-grid">
          {filteredItems.map(item => (
            <div key={item.id} className="gallery-item">
              <div
                className="gallery-image"
                onClick={() => setSelectedImage(item)}
              >
                <img src={item.image} alt={item.title} />
                <div className="gallery-overlay">
                  <div className="gallery-category"></div>
                  <div className="gallery-view">View</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ===== MODAL ===== */}
      {selectedImage && (
        <div className="gallery-modal" onClick={() => setSelectedImage(null)}>
          <div className="gallery-modal-content" onClick={e => e.stopPropagation()}>
            <span className="gallery-modal-close" onClick={() => setSelectedImage(null)}>
              ✖
            </span>
            <img src={selectedImage.image} alt={selectedImage.title} />
            {/* <h3>{selectedImage.title}</h3>
            <p>{selectedImage.description}</p> */}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Gallery;
